import { GUFEvent } from "@nens/brostar/openapi-client";
import {
  EditGUFAddRealisedInstallationTask,
  EditGUFClosureRealisedPartTask,
  EditGUFClosureTask,
  EditGUFExpandedRealisedInstallationTask,
  EditGUFHeightTask,
  EditGUFNewLicenceTask,
  EditGUFStartRegistrationTask,
  EditGUFWellFunctionTask,
  qualityRegimeOptionsType,
} from "@nens/brostar/uploadapi-client";

import { isValidEnum } from "./is-valid-enum";

/** Maps a GUFEvent.eventName to the URL slug for editing that event */
export const GUF_EVENT_NAME_TO_SLUG: Record<string, string> = {
  startRegistratie: "startregistratie",
  nieuwRecht: "nieuwe-vergunning",
  toevoegingGerealiseerdeInstallatie: "gerealiseerde-installatie-toevoegen",
  uitbreidingGerealiseerdeInstallatie: "gerealiseerde-installatie-uitbreiden",
  maaiveldhoogte: "hoogte",
  putfunctie: "putfunctie",
  beeindigingGerealiseerdOnderdeel: "gerealiseerd-deel-beeindigen",
  beeindiging: "beeindigen",
};

type AnyGufEditTask =
  | EditGUFStartRegistrationTask
  | EditGUFNewLicenceTask
  | EditGUFAddRealisedInstallationTask
  | EditGUFExpandedRealisedInstallationTask
  | EditGUFHeightTask
  | EditGUFWellFunctionTask
  | EditGUFClosureRealisedPartTask
  | EditGUFClosureTask;

/**
 * Converts a GUFEvent (fetched from the API) into an edit task by spreading the
 * event's metadata and sourcedocumentData onto the typed form structure.
 * The event's metadata already contains qualityRegime, broId, etc.
 */
export const convertGUFEventToEditTask = (event: GUFEvent): AnyGufEditTask => {
  const { metadata, sourcedocumentData } = event;
  const { qualityRegime, projectNumber, broId, deliveryAccountableParty } = metadata as {
    [key: string]: string;
  };

  return {
    sourcedocumentData: sourcedocumentData as AnyGufEditTask["sourcedocumentData"],
    metadata: {
      projectNumber: projectNumber ?? "",
      broId: broId ?? "",
      correctionReason: "eigenCorrectie",
      deliveryAccountableParty: deliveryAccountableParty ?? "",
      qualityRegime: isValidEnum(qualityRegimeOptionsType, qualityRegime),
      ...metadata,
    },
  } as AnyGufEditTask;
};
